import { isNil } from "lodash";

const hasCorporativeEmail = (email: string | null | undefined) => {
  if (isNil(email)) {
    return false;
  }
  const emailRegex = /^[a-zA-Z0-9._%+-]+@(evaluar\.com|grupocentrico\.com)$/;
  return emailRegex.test(email);
};

export default hasCorporativeEmail;
